import { createApp } from 'vue'
import ArcoVue from '@arco-design/web-vue';
import ArcoVueIcon from '@arco-design/web-vue/es/icon';
import '@arco-design/web-vue/dist/arco.css';
import Vant from 'vant';
import 'vant/lib/index.css';
import App from './App.vue'
import store from './store'
import router from './router'

const app = createApp(App)
app.use(ArcoVue)
app.use(ArcoVueIcon)
app.use(Vant)
app.use(store)
app.use(router)
app.mount('#app')